import { render, staticRenderFns } from "./PaymentAndSubscription.vue?vue&type=template&id=5dcb183e&scoped=true&"
import script from "./PaymentAndSubscription.vue?vue&type=script&lang=js&"
export * from "./PaymentAndSubscription.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAndSubscription.vue?vue&type=style&index=0&id=5dcb183e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcb183e",
  null
  
)

export default component.exports